/**
 * <tabs-component> / <tabs-navigation>: tabs of sections/tabbed-content.liquid.
 */
if (!customElements.get("tabs-component")) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
    }

    setActiveTab(handle) {
      this.querySelectorAll("[data-handle]").forEach((tab) => {
        tab.setAttribute("aria-hidden", "true");

        if (tab.getAttribute("data-handle") === handle) {
          const carouselComponent = tab.querySelector("carousel-slider");
          tab.setAttribute("aria-hidden", "false");

          if (carouselComponent) {
            carouselComponent.flickity.resize();
          }
        }
      });
    }

    // Activates a tab and syncs its navigation (used by <cdx-product-tabs>)
    openTab(handle) {
      this.setActiveTab(handle);
      document
        .querySelectorAll(`tabs-navigation[for="${this.id}"]`)
        .forEach((navigation) => navigation.markActive(handle));
      this.dispatchEvent(new CustomEvent("tabs:change", { bubbles: true, detail: { handle } }));
    }
  }

  customElements.define("tabs-component", TabsComponent);

  class TabsNavigation extends HTMLElement {
    constructor() {
      super();

      this.sliderId = this.getAttribute("for");
      this.navs = this.querySelectorAll("a, button");
      this.navs.forEach((nav) => {
        nav.addEventListener("click", this.onNavigationClick.bind(this, nav));
      });
    }

    onNavigationClick(element, event) {
      event.preventDefault();
      this.setActiveTab(element);
    }

    setActiveTab(nav) {
      const target = nav.getAttribute("data-handle");
      const tabsComponent = document.querySelector(`#${this.sliderId}`);

      if (!tabsComponent) {
        return;
      }

      tabsComponent.setActiveTab(target);

      this.navs.forEach((element) => {
        if (element === nav) {
          element.classList.add("is-active");
        } else {
          element.classList.remove("is-active");
        }
      });
    }

    markActive(handle) {
      this.navs.forEach((element) => {
        element.classList.toggle("is-active", element.getAttribute("data-handle") === handle);
      });
    }
  }

  customElements.define("tabs-navigation", TabsNavigation);
}
